import styled from "styled-components";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ $mb }) => $mb ?? "1rem"};
`;

const Title = styled.h2`
  font-size: ${({ theme }) => theme.font.sectionTitle};
  font-weight: 700;
  color: hsl(${({ theme }) => theme.colors.foreground});
  margin: 0;
`;

const SideLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: clamp(0.875rem, 0.82rem + 0.2vw, 1rem);
  font-weight: 500;
  color: hsl(${({ theme }) => theme.colors.primary});
  &:hover {
    text-decoration: underline;
  }
`;

export default function SectionHeaderRow({ title, to, linkLabel, marginBottom }) {
  return (
    <Row $mb={marginBottom}>
      <Title>{title}</Title>
      {to && linkLabel && (
        <SideLink to={to}>
          {linkLabel}
          <ChevronRight size={16} strokeWidth={2} />
        </SideLink>
      )}
    </Row>
  );
}
